import { render } from "./QuotationAndProdModule.vue?vue&type=template&id=a4860662&lang=html"
import script from "./QuotationAndProdModule.vue?vue&type=script&lang=js"
export * from "./QuotationAndProdModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__